import React, { useEffect, useState } from "react";
import {
  Flex,
  Text,
  Button,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Image,
  Box,
} from "@chakra-ui/react";
import { useDisclosure, useMediaQuery } from "@chakra-ui/react";
import { useLocation, useNavigate } from "react-router-dom";
import SideDrawer from "./SideDrawer";
import { IoIosArrowDown, IoMdMenu } from "react-icons/io";
import { dropdown } from "../../../common/constants";
import { useLogOut } from "../../../../utils/helpers";
import { useGetUser } from "../../../../services/query/account";

const Header = () => {
  const [isMobile] = useMediaQuery("(max-width: 991px)");
  const { data, refetch } = useGetUser();
  const { pathname } = useLocation();

  useEffect(() => {
    refetch();
  }, [pathname]);

  const navigate = useNavigate();
  const logOut = useLogOut();
  const { isOpen, onClose, onOpen } = useDisclosure();
  const [title, setTitle] = useState("");

  useEffect(() => {
    switch (true) {
      case pathname.includes("dashboard"):
        return setTitle("Dashboard");

      case pathname.includes("clients"):
        return setTitle("Clients");

      case pathname.includes("audits/acc"):
        return setTitle("Account Mgt. Audits");

      case pathname.includes("audits/trans"):
        return setTitle("Transaction Mgt. Audits");

      case pathname.includes("transactions/all"):
        return setTitle("All Transactions");

      case pathname.includes("transactions/pre"):
        return setTitle("Pre-Approvals");

      case pathname.includes("profile"):
        return setTitle("Profile");

      case pathname.includes("settings"):
        return setTitle("Settings");

      case pathname.includes("client/kyc"):
        return setTitle("Client's KYC");

      default:
        return setTitle("");
    }
  }, [pathname]);

  return (
    <Flex
      flexDirection="column"
      border="1px solid #D6D6D6"
      borderBottom="1px solid #D6D6D6"
      bg="#FAFAFA"
      borderTopRadius="32px"
      w="100%"
      py="30px"
      px={isMobile ? "20px" : "44px"}
      mt={{ base: "0px", md: "20px" }}
      color="#000"
    >
      <Flex justifyContent="space-between" align="center" w="full">
        <Flex justifyContent="space-between" align="center" w="full">
          <Flex align="flex-end" gap="4px">
            <Text
              color="#0F172A"
              fontSize={{ base: "16px", md: "24px" }}
              lineHeight={{ base: "20px", md: "30px" }}
              fontWeight={700}
            >
              {title}
            </Text>
          </Flex>
          <Flex align="center" gap="8px">
            <Image src="/assets/notification.png" w="26px" h="26px" />

            <Menu>
              <MenuButton
                as={Button}
                rightIcon={<IoIosArrowDown color="#242628" />}
                borderRadius="8px"
                bg="transparent"
                p="6px"
                fontSize="12px"
                px="15px"
                fontWeight="600"
                h="32px"
                border="1px solid #E4E6E8"
                color="#242628"
              >
                {data?.data?.name}
              </MenuButton>
              <MenuList
                borderRadius="4px"
                p="10px"
                border="1px solid #F4F6F8"
                boxShadow="0px 8px 16px 0px rgba(0, 0, 0, 0.08)"
                color="#080761"
                fontSize="12px"
              >
                {dropdown.map((item, i) => (
                  <MenuItem
                    key={i}
                    onClick={() =>
                      !item.label.includes("Log")
                        ? navigate(item.route)
                        : logOut()
                    }
                  >
                    {item.label}
                  </MenuItem>
                ))}
              </MenuList>
            </Menu>

            <Box display={{ base: "block", md: "none" }}>
              <IoMdMenu onClick={onOpen} size="20px" />
            </Box>
          </Flex>
        </Flex>
      </Flex>

      <SideDrawer isOpen={isOpen} onClose={onClose} />
    </Flex>
  );
};

export default Header;
